export const FETCH_COUNTRY_STATES_REQUEST='FETCH_COUNTRY_STATES_REQUEST'
export const FETCH_COUNTRY_STATES_SUCCESS='FETCH_COUNTRY_STATES_SUCCESS'
export const FETCH_COUNTRY_STATES_FAILURE='FETCH_COUNTRY_STATES_FAILURE'

